// Single source of truth for department & location display labels.
//
// jobsData.js stores the short `value` (e.g. "operations") on each job.
// Everywhere that needs to SHOW a department/location — the filter
// dropdowns, job card badges, the job detail hero banner — looks up the
// friendly `label` from here instead of hard-coding text.
//
// Why this split: rename "Sales & Marketing" to "Sales & BD" here and
// every job, badge, and dropdown updates at once — you never have to
// hunt down and retype it across multiple job entries.
//
// Adding a new department/location:
//   1. Add a { value, label } row below.
//   2. Use that same `value` string in jobsData.js for any job in that
//      department/location.
// If a job ever has a value that isn't listed here, the lookup functions
// just show the raw value as a fallback — nothing breaks, it just won't
// have a "nice" label until you add it below.

export const DEPARTMENTS = [
  { value: "sales-marketing", label: "Sales and Marketing" },
  { value: "finance-accounts", label: "Finance and Accounts" },
  { value: "operation", label: "Operation" },
  { value: "quality-assurance", label: "Quality Assurance" },
];

export const LOCATIONS = [
  { value: "vu-nagar-anand", label: "V.U.Nagar, Anand" },
  { value: "remote-multi", label: "Remote - Delhi/Bangalore/Chennai/Hyderabad" },
];

function lookupLabel(list, value) {
  const match = list.find((item) => item.value === value);
  return match ? match.label : value; // fallback: show the raw value rather than blank/undefined
}

export function getDepartmentLabel(value) {
  return lookupLabel(DEPARTMENTS, value);
}

export function getLocationLabel(value) {
  return lookupLabel(LOCATIONS, value);
}
